import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Warning, Title, DesyncButton } from './DesynchronizeComponents';
import ActivityPopoverContainer from './ActivityPopoverContainer';
import AssignedClassrooms from './AssignedClassrooms';
import * as bookActions from '../../../actions/bookActions';

class LinkedActivityPopover extends Component {
  openReveal = () => {
    const { activityId, bookActions } = this.props;
    bookActions.openDesynchronizeActivityReveal(activityId);
  };

  render() {
    const { linkedClassrooms, activeClassrooms, disableUnlinkContent } = this.props;

    return (
      <ActivityPopoverContainer>
        <Title>{I18n.t('bookContainer.classroomSynchronizedContent')}</Title>
        <AssignedClassrooms synchronizedClassrooms={linkedClassrooms} activeClassrooms={activeClassrooms} />
        <Warning>{I18n.t('bookContainer.classroomSynchronizedWarning')}</Warning>
        {!disableUnlinkContent && (
          <DesyncButton onClick={this.openReveal}>
            <div>{I18n.t('bookContainer.desynchronize')}</div>
          </DesyncButton>
        )}
      </ActivityPopoverContainer>
    );
  }
}

LinkedActivityPopover.propTypes = {
  activityId: PropTypes.string.isRequired,
  linkedClassrooms: PropTypes.array,
  activeClassrooms: PropTypes.array,
  disableUnlinkContent: PropTypes.bool,
  bookActions: PropTypes.object
};

const mapStateToProps = state => ({
  activeClassrooms: state.classrooms.activeClassrooms,
  disableUnlinkContent: state.account.configuration.disableUnlinkContent
});

const mapDispatchToProps = dispatch => ({
  bookActions: bindActionCreators(bookActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LinkedActivityPopover);
